// @flow
import styled from 'styled-components';
import { cleanWhite, jetBlack } from '../../colors';
import { media } from '../..';
import PrimaryButtonTheme from '../../buttons/primary/theme';
/*::
import type { Node } from 'react';
import type { PrimaryButtonThemeType } from '../../buttons/primary/theme';

export type CardThemeType = {
    CardImgGradient: * => Node,
    CardImgText: * => Node,
    CardImgInfo: * => Node,
    CardImgInfoLogo: * => Node,
    CardImgInfoText: * => Node,
    CardImgInfoButton: PrimaryButtonThemeType,
    CardImgItem: * => Node,
}
*/

var CardTheme
/*: CardThemeType */
= {
  CardImgGradient: styled.div.withConfig({
    displayName: "theme__CardImgGradient",
    componentId: "xwzhi8-0"
  })(["position:absolute;top:0;left:0;width:100%;height:100%;border-radius:1.2rem;background:linear-gradient( to bottom,rgba(0,0,0,0),rgba(0,0,0,0) 42%,", ");"], jetBlack()),
  CardImgText: styled.div.withConfig({
    displayName: "theme__CardImgText",
    componentId: "xwzhi8-1"
  })(["box-sizing:border-box;position:absolute;bottom:0;left:0;width:100%;padding:3.2rem 2rem 3.2rem 3.2rem;text-transform:uppercase;color:", ";font-size:4.7rem;", "{font-size:3.1rem;}"], cleanWhite(), media.md),
  CardImgInfo: styled.div.withConfig({
    displayName: "theme__CardImgInfo",
    componentId: "xwzhi8-2"
  })(["opacity:0;display:flex;flex-direction:column;align-items:flex-start;box-sizing:border-box;position:absolute;bottom:-3rem;left:0;width:100%;height:50%;padding:.8rem 1.6rem 0 1.6rem;z-index:100;transition:opacity .5s,bottom .5s;&:before{content:\"\";position:absolute;top:-8%;left:0;height:50%;width:100%;background-color:", ";transform:skewY(10deg);z-index:-1;}&:after{content:\"\";position:absolute;bottom:0;left:0;height:70%;width:100%;background-color:", ";border-radius:0 0 1.2rem 1.2rem;z-index:-1;}"], function (pr) {
    return pr.infoColor;
  }, function (pr) {
    return pr.infoColor;
  }),
  CardImgInfoLogo: styled.img.withConfig({
    displayName: "theme__CardImgInfoLogo",
    componentId: "xwzhi8-3"
  })(["", "{max-height:3.2rem;}"], media.md),
  CardImgInfoText: styled.div.withConfig({
    displayName: "theme__CardImgInfoText",
    componentId: "xwzhi8-4"
  })(["flex-grow:1;padding:1.6rem 0 0 0;color:", ";font-size:2rem;", "{font-size:1.6rem;}"], cleanWhite(), media.md),
  CardImgInfoButton: Object.assign({}, PrimaryButtonTheme, {
    Button: styled(PrimaryButtonTheme.Button).withConfig({
      displayName: "theme__Button",
      componentId: "xwzhi8-5"
    })(["align-self:center;width:17.6rem;margin:0 0 4.2rem 0;font-size:1.6rem;", "{margin-bottom:1.5rem;}"], media.md),
    Hover: styled(PrimaryButtonTheme.Hover).withConfig({
      displayName: "theme__Hover",
      componentId: "xwzhi8-6"
    })(["padding:0;"])
  }),
  CardImgItem: styled.div.withConfig({
    displayName: "theme__CardImgItem",
    componentId: "xwzhi8-7"
  })(["position:relative;overflow:hidden;border-radius:0 0 1.2rem 1.2rem;&:hover .card-img-info{opacity:1;bottom:0;transition:opacity 0s,bottom .5s;}& > *:first-child{width:32.8rem;height:52.8rem;border-radius:1.2rem;", "{width:26.1rem;height:42.1rem;}}"], media.md)
};
export default CardTheme;